import objectToFormData from '../utils/_objectToFormData';
import wishlist from '../utils/_wishlist';
import getCurrentPageClass from '../utils/_pageClass';
import dySendEngagement from '../utils/_dyHelpers';

class mTileOverlay extends HTMLDivElement {
    constructor() {
        super();
        this.btnWishlist = this.querySelector('.btn-wishlist');
        this.pid = this.closest('[is="m-product-tile"]').dataset.pid;
        this.isInsideSearchBar = this.closest('[is="o-sidebar-ajax"]') !== null;
        this.personnalizedVariation = document.querySelector('.js-dyEngagement')?.dataset.personnalizedVariation;
        this.decisionId = document.querySelector('.js-dyEngagement')?.dataset.decisionId;
        this.slotId = document.querySelector('.js-dyEngagement')?.dataset.slotId;
        this.engagementUrl = document.querySelector('.js-dyEngagement')?.dataset.engagementUrl;
        this.currentPage = getCurrentPageClass();

        this.addOrRemoveToWishlist = this.addOrRemoveToWishlist.bind(this);
    }

    connectedCallback() {
        if (this.btnWishlist) {
            this.btnWishlist.addEventListener('click', this.addOrRemoveToWishlist);
        }
    }

    disconnectedCallback() {
        if (this.btnWishlist) {
            this.btnWishlist.removeEventListener('click', this.addOrRemoveToWishlist);
        }
    }

    addOrRemoveToWishlist() {
        const svgIcon = this.querySelector('svg');
        const wishListUrl = GLOBAL_KZ.addToWishlistUrl;
        const wishlistLink = GLOBAL_KZ.wishlistUrl;
        let currentImgUrl = '';
        const currentImgAlt = '';
        const sliderContainer = this.closest('.tile-header').querySelector('[is="m-tile-slider"]');

        if (this.isInsideSearchBar) {
            currentImgUrl = this.closest('.tile-header').querySelector('.swiper .swiper-slide img').currentSrc;
        } else if (this.currentPage === 'pdp') {
            let image = this.closest('.tile-header').querySelector('[is="m-tile-images"] picture[hidden] img');
            if (!image || !image.currentSrc) {
                image = this.closest('.tile-header').querySelector('[is="m-tile-images"] picture img');
            }
            currentImgUrl = (image && image.currentSrc) || '';
        } else if (sliderContainer && window.getComputedStyle(sliderContainer).display === 'none') {
            // desktop/video case : get current hover image
            const tileHeader = this.closest('.tile-header');
            let image = tileHeader.querySelector('[is="m-tile-images"] picture[hidden] img');
            if (!image) {
                // Case video in product tile, use video image placeholder
                image = tileHeader.querySelector('[is="m-tile-video"] video img');
            }
            currentImgUrl = (image && image.currentSrc) || '';
        } else {
            const currentSlider = this.closest('.tile-header').querySelector('[is="m-tile-slider"]');
            if (currentSlider) {
                const isSliderInited = currentSlider.classList.contains('swiper-initialized');
                // mobile case : should be a slider, get current slider image.
                if (isSliderInited) {
                    currentImgUrl = currentSlider.querySelector('.swiper-wrapper .swiper-slide-active img').currentSrc;
                } else {
                    currentImgUrl = currentSlider.querySelector('.swiper-wrapper .swiper-slide img').currentSrc;
                }
            } else {
                const currentImage = this.closest('.tile-header').querySelector('[is="m-tile-images"] picture img');
                currentImgUrl = (currentImage && currentImage.currentSrc) || '';
            }
        }

        const data = objectToFormData({
            pid: this.pid,
            optionId: null,
            optionVal: null,
            siteLocation: 'PLP',
        });

        if (this.personnalizedVariation) {
            dySendEngagement.sendEngagement({
                engagementUrl: this.engagementUrl,
                decisionId: this.decisionId,
            });
        }

        // Ajax call to Wishlist API
        wishlist.addOrRemoveToWishlist(wishListUrl, wishlistLink, data, currentImgUrl, currentImgAlt, svgIcon);
    }
}

customElements.define('m-tile-overlay', mTileOverlay, {
    extends: 'div',
});
